import { ViteEnv } from '@/env';

import { supabaseClient } from '../supabase';

const fetchWithToken = async (url: string, init: RequestInit, token: string) =>
  fetch(url, {
    ...init,
    headers: {
      ...init.headers,
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

export const fetchBackend = async (
  relativeUrl: string,
  init: RequestInit,
  authenticated = true,
): Promise<Response> => {
  const url = `${ViteEnv.VITE_BACKEND_URL}${relativeUrl}`;

  if (!authenticated) {
    return fetch(url, {
      ...init,
      headers: {
        'Content-Type': 'application/json',
        ...init.headers,
      },
    });
  }

  const {
    data: { session },
  } = await supabaseClient.auth.getSession();

  if (!session) {
    throw new Error('No session found');
  }

  const response = await fetchWithToken(url, init, session.access_token);

  if (response.ok || response.status !== 401) {
    return response;
  }

  const {
    data: { session: newSession },
  } = await supabaseClient.auth.refreshSession(session);

  if (newSession === null) {
    return response;
  }

  return fetchWithToken(url, init, newSession.access_token);
};
